import { c as _c } from "react/compiler-runtime";
import { CopyableContent } from "@/src/components/copyable-content";
import { useComparison } from "@/src/context/comparison-text";
import { getDisplayValue, compareStrings, FieldType } from "@/src/lib/utils/string-utils";
interface ComparisonFieldProps {
  label: string;
  value: string;
  secondaryValue: string;
  type?: FieldType;
  compareAgainstTitle?: string;
}
export function ComparisonField(t0) {
  const $ = _c(23);
  const {
    label,
    value,
    secondaryValue,
    type: t1,
    compareAgainstTitle: t2
  } = t0;
  const type = t1 === undefined ? "text" : t1;
  let compareAgainstTitle = t2 === undefined ? "EMR" : t2;
  const context = useComparison();
  if (context?.comparisonLabel) {
    compareAgainstTitle = context.comparisonLabel;
  }
  let t3;
  if ($[0] !== type || $[1] !== value) {
    t3 = getDisplayValue(value, type);
    $[0] = type;
    $[1] = value;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const formattedValue = t3;
  let t4;
  if ($[3] !== secondaryValue || $[4] !== type) {
    t4 = getDisplayValue(secondaryValue, type);
    $[3] = secondaryValue;
    $[4] = type;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const formattedSecondaryValue = t4;
  let t5;
  if ($[6] !== secondaryValue || $[7] !== type || $[8] !== value) {
    t5 = compareStrings(value, secondaryValue, type);
    $[6] = secondaryValue;
    $[7] = type;
    $[8] = value;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const hasConflict = !t5;
  let t6;
  if ($[10] !== label) {
    t6 = <span className="font-medium">{label}:</span>;
    $[10] = label;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const t7 = `${hasConflict ? "bg-warn/20" : "text-foreground"}`;
  let t8;
  if ($[12] !== formattedValue || $[13] !== t7) {
    t8 = <span><CopyableContent text={formattedValue} textClassName={t7} /></span>;
    $[12] = formattedValue;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== compareAgainstTitle || $[16] !== formattedSecondaryValue || $[17] !== hasConflict) {
    t9 = hasConflict && <div className="text-xs text-muted-foreground mt-1"><span className="text-warn dark:text-warn">{compareAgainstTitle}:{" "}<CopyableContent text={formattedSecondaryValue} textClassName="text-warn dark:text-warn" /></span></div>;
    $[15] = compareAgainstTitle;
    $[16] = formattedSecondaryValue;
    $[17] = hasConflict;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t6 || $[20] !== t8 || $[21] !== t9) {
    t10 = <div>{t6}{" "}{t8}{t9}</div>;
    $[19] = t6;
    $[20] = t8;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  return t10;
}